var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('div',{staticClass:"col-12 col-lg-2 divider-lg-right divider-bottom divider-lg-bottom-0 mb-3 mb-lg-0"},[_c('PatientProfile',{attrs:{"patient":_vm.patient,"button-name":"ข้อมูลติดต่อ","button-click":() => {
          _vm.editCustomer(_vm.patient);
        }}})],1),_c('div',{staticClass:"col-12 col-lg-10"},[_c('AppointmentHistoryTable',{attrs:{"patient":_vm.patient}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }